import React, { useState } from "react";
import { FaBox, FaCube, FaShoppingBag } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const models = [
  { name: "Fresco Combi", category: "Semi-Verticals", image: "images/fresccom.jpg", description: "A versatile semi-vertical display model for self-service restaurants.", route: "/FrescoCombi-lower" },
  { name: "United", category: "Multi decks", image: "images/united.png", description: "A multi-deck display model perfect for self-service restaurant environments.", route: "/united" },
  { name: "Vista Grab & Go", category: "Semi-Verticals", image: "images/vistagrabgo.jpg", description: "An innovative grab-and-go semi-vertical display model for restaurant use.", route: "/vista-grab-and-go" },
  { name: "Daisy", category: "Display", image: "images/daisy2.jpg", description: "An elegant, user-friendly model, designed to fit in both modern and classic coffee shops.", route: "/daisy-upper" },
  { name: "Victory", category: "Semi-Verticals", image: "images/victory.png", description: "A sleek and efficient semi-vertical display model for quick service and self-service applications.", route: "/victory" },
];




const icons = [
  { name: "Box", icon: <FaBox /> },
  { name: "Cube", icon: <FaCube /> },
  { name: "Shopping Bag", icon: <FaShoppingBag /> },
];

function Restaurentselfservice() {
  const [currentPage, setCurrentPage] = useState(1);
  const modelsPerPage = 6;
  const navigate = useNavigate();

  // Get the current models for the current page
  const indexOfLastModel = currentPage * modelsPerPage;
  const indexOfFirstModel = indexOfLastModel - modelsPerPage;
  const currentModels = models.slice(indexOfFirstModel, indexOfLastModel);

  // Handle page change
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(models.length / modelsPerPage);

  return (
    <div className="w-full font-thin">
      {/* Hero Section */}
      <section
        className="relative text-center w-full h-[600px]"
        style={{
          backgroundImage: "url('images/selfserviceland.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
       
      </section>

      {/* Models Display */}
      <section className="px-6 py-12 md:px-32">
        <section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Restaurant & Self-Service</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          For modern Catering we have created solutions for assisted service or self-service, horizontal and vertical displays for hot and cold food, drinks and delicious desserts!
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-6">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-6">Restaurant & Self-Service</button>
        </div>
      </section>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentModels.map((model, index) => (
            <div key={index} onClick={() => navigate(model.route)} className="text-center cursor-pointer">
              <div
                className="relative w-full h-80 mb-4"
                style={{
                  backgroundImage: `url(${model.image})`,
                  backgroundSize: "contain", // Ensures no cuts, full image shown
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  height: "300px",
                }}
              ></div>
              <h3 className="text-3xl uppercase font-thin mb-2">{model.name}</h3>
              {/* <p className="text-xl opacity-80 ">{model.category}</p> */}
              <p className="text-xl text-gray-500 max-w-sm opacity-80 mb-4 mx-auto">{model.description}</p>

              {/* Small icons under each model */}
              <div className="flex justify-center gap-4">
                {icons.map((icon, index) => (
                  <div key={index} className="text-2xl">
                    {icon.icon}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-10">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-800 text-white rounded-l"
          >
            Previous
          </button>
          <span className="px-4 py-2">{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-800 text-white rounded-r"
          >
            Next
          </button>
        </div>
      </section>
    </div>
  );
}


export default Restaurentselfservice;

// import React from "react";

// function Restaurentselfservice() {
//   const models = [
//     {
//       title: "United",
//       description:
//         "The United Multi Deck display offers superior visibility and efficient organization, perfect for high-traffic environments. Designed with advanced refrigeration technology, it ensures products remain fresh while being prominently displayed. Ideal for supermarkets, convenience stores, and restaurants.",
//       image: "images/united.png",
//     },
//     {
//       title: " Fresco Combi",
//       description:
//         "Fresco Combi offers a versatile solution for showcasing a variety of products with an organized and sleek design. Its ergonomic structure makes it easy to load and access items while providing energy-efficient performance. Perfect for enhancing the visual appeal of your product range.",
//       image: "images/freescombo1.webp",
//     },
//     {
//       title: " Vista Grab & Go",
//       description:
//         "Vista Grab & Go provides a practical, easy-access display for quick pick-ups while keeping your products visible and well-organized. It’s the ultimate solution for busy cafes and retail spaces, combining convenience with an attractive display format.",
//       image: "images/vistsgrab.jpg",
//     },
//     {
//       title: " Daisy",
//       description:
//         "Enhance your space with the elegant Daisy display, offering a stylish solution for showcasing smaller items. With its compact design and customizable features, Daisy seamlessly fits into limited spaces, making it a favorite for boutique stores and dessert counters.",
//       image: "images/daisy2.jpg",
//     },
//     {
//       title: " Victory",
//       description:
//         "Victory offers enhanced visibility and accessibility with a modern design, ideal for displaying premium products. Built with durable materials and equipped with energy-saving technology, it’s the perfect choice for businesses that value sustainability and style.",
//       image: "images/victory.png",
//     },
//   ];

//   return (
//     <div className=" bg-white font-playfair">
//       {/* Hero Section */}
//       <section
//         className="relative w-full h-screen"
//         style={{
//           backgroundImage: "url('images/selfserviceland.jpg')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white p-8 md:p-16">
//         <h1 className="text-5xl font-bold mb-4 md:text-8xl text-center">
//   Restaurant & Self Service
// </h1>
// <p className="text-xl max-w-2xl text-center md:text-2xl">
//   From versatile displays to modern designs, we offer everything you need to elevate your business and captivate your customers.
// </p>

//         </div>
//       </section>

//       {/* Models Section */}
//       <section className="px-6 py-16  items-center">
//         <h2 className="text-4xl xl:text-7xl font-bold text-center text-gray-800 mb-12 items-center">
//           Restaurant & Self-Service <br/> Models
//         </h2>

//         <div className="space-y-20 items-center">
//           {models.map((model, index) => (
//             <div
//               key={index}
//               className={`flex flex-col ${
//                 index % 2 === 0 ? "md:flex-row " : "md:flex-row-reverse "
//               } items-center gap-8`}
//             >
//               {/* Image */}
//               <div className="w-full md:w-1/2  ">
//                 <img
//                   src={model.image}
//                   alt={model.title}
//                   className="w-full h-auto object-contain "
//                 />
//               </div>

//               {/* Text Content */}
//               <div className="w-full md:w-1/3 text-center md:text-left px-4  items-center">
//                 <h3 className="text-4xl xl:text-6xl font-semibold text-gray-800 text-center mb-6">
//                   {model.title}
//                 </h3>
//                 <p className="mt-4 text-xl text-justify xl:text-3xl text-gray-700">{model.description}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Restaurentselfservice;
